var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-box1",style:({flex: _vm.flex})},[_c('div',{staticClass:"box1-title flex"},[_c('div',{staticClass:"tit-text",style:({width: _vm.width ? `${_vm.width}px` : 'auto'})},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticStyle:{"flex":"1"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }